export async function delay(ms: number, signal?: AbortSignal) {
  return new Promise((resolve, reject) => {
    const abortHandler = () => {
      clearTimeout(timeoutId);
      reject(new DOMException('Aborted', 'AbortError'));
    };

    if (signal?.aborted) {
      reject(new DOMException('Aborted', 'AbortError'));
      return;
    }

    const timeoutId = setTimeout(resolve, ms);

    if (signal) {
      signal.addEventListener('abort', abortHandler);
    }
  });
}
